// log
import store from "../store";

const fetchDataBase3Request = () => {
  return {
    type: "CHECK_DATABASE3_REQUEST",
  };
};

const fetchDataBase3Success = (payload) => {
  return {
    type: "CHECK_DATABASE3_SUCCESS",
    payload: payload,
  };
};

const fetchDataBase3Failed = (payload) => {
  return {
    type: "CHECK_DATABASE3_FAILED",
    payload: payload,
  };
};

export const fetchDataBase3 = (account) => {
  return async (dispatch) => {
    dispatch(fetchDataBase3Request());
    try {
      let imageURI = [];
      let tokenId = [];
      let walletOfOwner = await store
        .getState()
        .blockchain.smartContract3.methods.walletOfOwner(account)
        .call();
      tokenId = walletOfOwner;
      let timId;
      // Dateオブジェクトを作成
      var date = new Date();
      // UNIXタイムスタンプを取得する (ミリ秒単位)
      var nowUnixJs = date.getTime();
      // UNIXタイムスタンプを取得する (秒単位 - PHPのtime()と同じ)
      var nowUnix = Math.floor(nowUnixJs / 1000);
      let totalPoint = 0;
      let point = 0;
      for (let i = 0; i < walletOfOwner.length; i++) {
        timId = await store
          .getState()
          .blockchain.smartContract3.methods.getTokenTim(tokenId[i])
          .call();
        point = Math.floor((nowUnix - timId) / 86400);
        totalPoint += point;
        imageURI[tokenId[i]] = [
          i,
          // "https://startdata.io/NSK/" + String(tokenId[i]) + ".png?r=1",
          "https://startdata.io/PNL/" + String(tokenId[i]) + ".png?r=1",
          "#" + String(tokenId[i]),
          tokenId[i],
          point,
        ];
      }

      // let cost = await store
      //   .getState()
      //   .blockchain.smartContract.methods.cost()
      //   .call();

      dispatch(
        fetchDataBase3Success({
          imageURI,
          totalPoint,
        })
      );
    } catch (err) {
      console.log(err);
      dispatch(fetchDataBase3Failed("Could not load data from contract."));
    }
  };
};
